import { CheckedAddress } from '@sparkdotfi/common-universal'

import { transformSimplifiedQueryResult } from '@/domain/common/query'
import { useOngoingCampaignsQuery } from '@/features/spark-rewards/data/useOngoingCampaignsQuery'
import { MarketSparkRewards } from '@/features/spark-rewards/types'
import { assignMarketSparkRewards } from '@/features/spark-rewards/utils/assignMarketSparkRewards'
import { Reserve } from '@/features/sparklend/common/data/market-info/marketInfo'

export interface UseSparkRewardsByReserveParams {
  chainId: number
  reserves: Reserve[]
}

export type SparkRewardsByReserve = Record<
  CheckedAddress,
  { borrow: MarketSparkRewards[]; supply: MarketSparkRewards[] }
>

export function useSparkRewardsByReserve({ chainId, reserves }: UseSparkRewardsByReserveParams): SparkRewardsByReserve {
  const ongoingCampaignsResult = useOngoingCampaignsQuery()

  const { data } = transformSimplifiedQueryResult(ongoingCampaignsResult, (data) => {
    const campaigns = data
      .filter((campaign) => campaign.type === 'sparklend')
      .filter((campaign) => campaign.chainId === chainId)

    return reserves.reduce<SparkRewardsByReserve>((acc, reserve) => {
      acc[reserve.token.address] = {
        supply: assignMarketSparkRewards({
          campaigns,
          action: 'supply',
          reserveTokenSymbol: reserve.token.symbol,
          chainId,
        }),
        borrow: assignMarketSparkRewards({
          campaigns,
          action: 'borrow',
          reserveTokenSymbol: reserve.token.symbol,
          chainId,
        }),
      }
      return acc
    }, {})
  })

  return data ?? {}
}
